<div class="tabs">
  <div class="tab" *ngIf="colorTool">
    <button (click)="toggleTab('look')" [ngClass]="{ active: tabs.active === 'look' }">Look & Feel</button>
  </div>
  <div class="tab" *ngIf="panningTool || zoomingTool || bnTool">
    <button (click)="toggleTab('plugins')" [ngClass]="{ active: tabs.active === 'plugins' }">Plugins</button>
  </div>
  <div class="tab" *ngIf="minimapTool">
    <button (click)="toggleTab('minimap')" [ngClass]="{ active: tabs.active === 'minimap' }">Minimap</button>
  </div>
  <div class="tab" *ngIf="layersTool">
    <button (click)="toggleTab('layers')" [ngClass]="{ active: tabs.active === 'layers' }">Display level</button>
  </div>
  <div class="tab" *ngIf="avaTool">
    <button (click)="toggleTab('availability')" [ngClass]="{ active: tabs.active === 'availability' }">
      Availability
    </button>
  </div>
</div>

<div class="tabs-content">
  <app-sbeditor-tool-colormap
    *ngIf="colorTool"
    [hidden]="tabs.active !== 'look'"
    #colormap
    (exportTool)="getTool($event, 'colormap')"></app-sbeditor-tool-colormap>
  <app-sbeditor-tool-availability
    *ngIf="avaTool"
    [hidden]="tabs.active !== 'availability'"
    #availability
    (exportTool)="getTool($event, 'availability')"></app-sbeditor-tool-availability>
  <app-sbeditor-tool-minimap
    *ngIf="minimapTool"
    [hidden]="tabs.active !== 'minimap'"
    #minimap
    (exportTool)="getTool($event, 'minimap')"></app-sbeditor-tool-minimap>
  <app-sbeditor-tool-panning
    *ngIf="panningTool"
    [hidden]="tabs.active !== 'plugins'"
    #panning
    (exportTool)="getTool($event, 'panning')"></app-sbeditor-tool-panning>
  <app-sbeditor-tool-zooming
    *ngIf="zoomingTool"
    [hidden]="tabs.active !== 'plugins'"
    #zooming
    (exportTool)="getTool($event, 'zooming')"></app-sbeditor-tool-zooming>
  <app-sbeditor-tool-bestnode
    *ngIf="bnTool"
    [hidden]="tabs.active !== 'plugins'"
    #bestnode
    (exportTool)="getTool($event, 'bestnode')"></app-sbeditor-tool-bestnode>
    <app-sbeditor-tool-layers
    *ngIf="layersTool"
    [hidden]="tabs.active !== 'layers'"
    #layers
    (exportTool)="getTool($event, 'layers')"></app-sbeditor-tool-layers>
</div>

<div class="tabs-bottom">
  <button class="btn-secondary-action" (click)="save()">Aplicar cambios</button>
</div>
